
export default {
  props: {
    blok: {
      type: Object,
      default: () => ({
        content: [],
        avatars: [],
      }),
    },
  },
  data() {
    return {
      pinSelectedId: '',
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
      this.setNavColorChangeScrollTrigger()
    })
  },
  methods: {
    init() {
      this.$gsap.set('.avatar', {
        opacity: 0,
        scale: 0.8,
      })

      this.$gsap.from('.well-faculty-graphic path', {
        drawSVG: 0,
        duration: 1.5,
        onComplete: () => {
          this.$gsap
            .timeline()
            .to('.avatar', {
              opacity: 1,
              scale: 1,
            })
            .fromTo(
              '.faculty-rings',
              {
                rotation: 0,
              },
              {
                rotation: 360,
                duration: 150,
                repeat: -1,
                ease: 'linear',
                transformOrigin: 'center center',
              },
              0
            )

          if (!this.$matchMedia('sm')) {
            return
          }

          const tweenProperty = (target, prop, min, max) => {
            const randomDur = this.$gsap.utils.random(3, 6, 0.2, true)
            const randomDelay = this.$gsap.utils.random(0.6, 2, 0.2, true)

            this.$gsap.to(target, {
              [prop]: this.$gsap.utils.random(min, max),
              duration: randomDur(),
              delay: randomDelay(),
              ease: 'none',
              onComplete: tweenProperty,
              onCompleteParams: [target, prop, min, max],
            })
          }

          // Animate the properties individually
          this.$gsap.utils.toArray('.avatar').forEach((star) => {
            // tweenProperty(star, "scale", 0.5, 4);
            tweenProperty(star, 'x', -12, 12)
            tweenProperty(star, 'y', -12, 12)
          })
        },
      })
    },
    setNavColorChangeScrollTrigger() {
      const navigation = document.querySelector('#nav-header-pin')
      const aspot = document.querySelector('#faculty-aspot')

      if (!aspot) return

      // change nav bg color when scrolling past Aspot
      this.$gsap.timeline({
        scrollTrigger: {
          trigger: aspot,
          start: '-100% top',
          // end: 'bottom bottom',
          // markers: true,
          onEnter: () => {
            navigation.firstChild.classList.remove('blur-bg')
            navigation.firstChild.classList.add(
              this.$store.state.settings.mainNavStyle
            )
          },
          onLeave: () => {
            navigation.firstChild.classList.remove(
              this.$store.state.settings.mainNavStyle
            )
            navigation.firstChild.classList.add('blur-bg')
          },
          onEnterBack: () => {
            navigation.firstChild.classList.remove('blur-bg')
            navigation.firstChild.classList.add(
              this.$store.state.settings.mainNavStyle
            )
          },
          onLeaveBack: () => {
            navigation.firstChild.classList.remove(
              this.$store.state.settings.mainNavStyle
            )
            navigation.firstChild.classList.add('blur-bg')
          },
        },
      })
    },
    setId(id) {
      this.pinSelectedId = id
    },
  },
}
